import axios from 'axios';

class UserService {
    static registerUser = (body) => axios.post('/auth/register', body);

    static activateAccount = (body) => axios.put('/auth/activate', body);

    static loginUser = (body) => axios.post('/auth/login', body);

    static resendCode = (body) => axios.post('/auth/resend-code', body);

    static updateUser = (id, body) => axios.put(`/users/update/${id}`, body);

    static forgotPassword = (body) => axios.post('/users/forgot-password', body);

    static resetPassword = (body) => axios.post('/users/reset-password', body);

    static changePassword = (id, body) => axios.put(`/users/change-password/${id}`, body);

    static getLoggedUser = () => axios.get('/users/get-logged-user');

    static getUser = (id) => axios.get(`/users/${id}`);

    static deleteUser = (id) => axios.delete(`/users/delete/${id}`);
}

export default UserService;
